import {CheckboxTreeNode} from './checkbox-tree.interface';

export class CheckboxTreeItem implements CheckboxTreeNode {
    label: string;
    value?: any;
    children?: Array<CheckboxTreeItem>;
    parent: CheckboxTreeItem;

    constructor(node: CheckboxTreeNode, parent: CheckboxTreeItem) {
        Object.keys(node).forEach(key => (this[key] = node[key]));
        this.label = node.label;
        this.value = node.value === undefined ? null : node.value;
        this.parent = parent;
    }

    setChildren(children: Array<CheckboxTreeItem>) {
        this.children = children;
    }

    hasChildren(): boolean {
        return Array.isArray(this.children) && !!this.children.length;
    }

    getValue(): any {
        return this.value !== null ? this.value : this.label;
    }
}
